import { Outlet } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import CookieBanner from "./CookieBanner";
import ScrollToTop from "./ScrollToTop";

const SiteLayout = () => (
  <>
    <SiteHeader />
    <main className="min-h-screen">
      <Outlet />
    </main>
    <SiteFooter />
    <ScrollToTop />
    <CookieBanner />
  </>
);

export default SiteLayout;
